// Cache keys
export var TRANSLATION_DATA_KEY = 'translationData';
export var CENTRAL_PROFILE_KEY = 'centralProfile';
export var AUTH0_RESULT_KEY = 'auth0Result';
export var EXPIRATION_TOKEN_KEY = 'sessionExpiration';
export var TERMS_ACCEPTED_KEY = 'termsAccepted';
export var TERMS_OF_USE = 'terms_of_use';
export var TERMS_OF_SERVICE = 'terms_of_service';
export var PRIVACY_POLICY = 'privacy_policy';
export var DEVELOPMENT_MODE = !!process.env.REACT_APP_DEV_MODE;
if (DEVELOPMENT_MODE) {
    // eslint-disable-next-line no-console
    console.info("\n    You are on working on DEVELOPMENT_MODE.\n    This will cache your profile and session information.\n    To clear it you can logout or clean your local storage\n ");
}
//# sourceMappingURL=constants.js.map